import { NavLink, Outlet, useLocation } from "react-router-dom";
import { FiUser, FiList, FiSettings, FiLogOut, FiBookmark } from "react-icons/fi";
import { useAuth } from "../contexts/AuthContext";
import { auth } from "../firebase/firebaseConfig";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import routePaths from "../routes/routePaths";

const accountTabs = [
  { label: "Hồ sơ", icon: <FiUser />, path: routePaths.profile },
  { label: "Bài tập", icon: <FiBookmark />, path: routePaths.STUDENT_ASSIGNMENTS },
  { label: "Kết quả", icon: <FiList />, path: routePaths.myResults },
  { label: "Cài đặt", icon: <FiSettings />, path: routePaths.accountSettings },
];

export default function AccountLayout() {
  const { user, userExt } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const isStudentArea = location.pathname.startsWith("/students");

  // Đăng xuất
  const handleLogout = async () => {
    await auth.signOut();
    toast.success("Đã đăng xuất.");
    navigate("/login");
  };

  return (
    <div className={`${isStudentArea ? "role-theme-surface" : ""} max-w-5xl mx-auto px-3 py-10`}>
      {/* User info header (avatar, tên) */}
      <div className="flex flex-col sm:flex-row items-center gap-4 mb-8">
        <img
          src={userExt?.avatar || user?.photoURL || "/default-avatar.png"}
          alt="Avatar"
          className="w-16 h-16 rounded-full object-cover border-2 border-primary shadow"
        />
        <div className="flex-1 text-center sm:text-left">
          <h2 className="text-xl font-bold text-primary">
            {userExt?.displayName || user?.displayName || "Tài khoản của bạn"}
          </h2>
          <div className="text-menu text-sm">{user?.email}</div>
        </div>
        {/* Nút logout (desktop) */}
        <button
          className="hidden sm:inline-flex items-center gap-2 bg-error/10 text-error px-4 py-2 rounded-lg font-semibold shadow hover:bg-error/20 transition"
          onClick={handleLogout}
        >
          <FiLogOut /> Đăng xuất
        </button>
      </div>

      {/* Tab navigation */}
      <div className="flex gap-1 mb-8 border-b border-border overflow-x-auto no-scrollbar">
        {accountTabs.map(tab => (
          <NavLink
            key={tab.path}
            to={tab.path}
            className={({ isActive }) =>
              `flex items-center gap-2 px-4 py-2 rounded-t-lg font-semibold transition-all whitespace-nowrap
       ${isActive || location.pathname === tab.path
                ? "bg-card border-b-2 border-primary text-primary -mb-[1px]"
                : "text-menu hover:bg-card/70"
              }`
            }
            end
          >
            {tab.icon}
            <span className="hidden sm:inline">{tab.label}</span>
            {/* Chỉ hiện text khi >= sm (640px) */}
          </NavLink>
        ))}

        {/* Nút logout (mobile/tabbar) */}
        <button
          className="flex items-center gap-2 px-4 py-2 rounded-t-lg font-semibold text-error hover:bg-error/10 transition-all sm:hidden"
          onClick={handleLogout}
        >
          <FiLogOut /> <span className="hidden xs:inline">Đăng xuất</span>
        </button>
      </div>

      {/* Tab content */}
      <div className="bg-card rounded-xl shadow p-5 min-h-[300px]">
        <Outlet />
      </div>
    </div>
  );
}
